export class Pages {
  getPageRoute(router: any) {
    return router.currentRoute.name
  }

  getPageName(pageRoute: string | null | undefined) {
    let pageName = ''

    if (typeof pageRoute === 'string' && pageRoute.search('___') !== -1) {
      pageName = pageRoute.substr(0, pageRoute.length - 5)

      if (pageName.search('___') !== -1) {
        pageName = pageName.substr(0, pageName.length - 5)
      }
    }
    return pageName
  }

  getPageStr(pageName: string) {
    return 'pages.' + pageName
  }
}
